import AuthService from "./AuthService";
import { UtilitiesService } from "./UtilitiesService";


export class ApiService {
    private baseUrl: string;
    private token: string | null = null;


    constructor() {
        this.baseUrl = UtilitiesService.getApiUrl();
    }

    static async create() {
        const service = new ApiService();
        await service.initialize();
        return service;
     }
    

    async initialize() {
        this.token = await AuthService.getToken();
    }

    public async get(uri: string):Promise<Response>  {
        const url = this.baseUrl + uri;

        const headers = {
            'Authorization': 'Bearer ' + this.token,
        };

        const requestInit = {
            credentials: 'include',
            headers: headers,
            mode: "cors",
            cache: "no-cache"
        }

        const response = await fetch(url, requestInit as RequestInit);
        this.invalidateTokenIfRejected(response);
        return response;
    }

    public async post(uri: string, data: any):Promise<Response> {
        const headers = {
            'Authorization': 'Bearer ' + this.token,
            'Content-Type': 'application/json'
        };

        const requestOptions = {
            credentials: 'include',
            headers: headers,
            mode: "cors",
            method: 'POST',
            body: JSON.stringify(data)
        }

        const url = this.baseUrl + uri;

        const response = await fetch(url, requestOptions as RequestInit);
        this.invalidateTokenIfRejected(response);
        return response;
    }

    /**
     * A 401/403 means the token this instance is holding is no longer accepted (expired,
     * IP-pinned to a different request, etc). Clearing it here as well as in AuthService
     * means the next mount/instance fetches a fresh token instead of replaying the same
     * rejected one indefinitely.
     */
    private invalidateTokenIfRejected(response: Response) {
        if (response.status === 401 || response.status === 403) {
            this.clearToken();
            AuthService.invalidateToken();
        }
    }

    public clearToken() {
        this.token = null;
    }

    public getToken() {
        return this.token;
    }

    public clearSession() {
        window.sessionStorage.clear();
    }

}

